import { render } from "./ModalTermAndConditios.vue?vue&type=template&id=0a1fbe2a&scoped=true"
import script from "./ModalTermAndConditios.vue?vue&type=script&lang=js"
export * from "./ModalTermAndConditios.vue?vue&type=script&lang=js"

import "./ModalTermAndConditios.vue?vue&type=style&index=0&id=0a1fbe2a&rel=scss&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a1fbe2a"]])

export default __exports__